import { Slide } from '../types';

/**
 * Composes multiple slide definitions into a single slide.
 * Only the first detected slide master definition, background,
 * and color will be used.
 *
 * @param slideDefinitions - The slide definitions to compose.
 * @returns The composed slide.
 */
export const composeSlides = (...slideDefinitions: Slide[]): Slide => {
  return slideDefinitions.reduce((acc, slide) => {
    return {
      slideMaster: acc.slideMaster ?? slide.slideMaster,
      background: acc.background ?? slide.background,
      color: acc.color ?? slide.color,
      texts: [...(acc.texts ?? []), ...(slide.texts ?? [])],
      images: [...(acc.images ?? []), ...(slide.images ?? [])],
      shapes: [...(acc.shapes ?? []), ...(slide.shapes ?? [])],
      tables: [...(acc.tables ?? []), ...(slide.tables ?? [])],
      charts: [...(acc.charts ?? []), ...(slide.charts ?? [])],
    };
  }, {});
};
